import React, { useEffect, useState } from "react";
import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";
import Form from "react-bootstrap/Form";
import Navigation from "../Navigation/Navigation";
import { Link, useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import { GetCity, GetCountry, GetState } from "../../Utils/Api/SignUP";
import AutoCompleteInput from "../../Components/AutoCompleteInput/AutoCompleteInput";
import { AddNewCardApi } from "../../Utils/Api/AddNewCardApi";
import { userId } from "../../Utils/LocalStorage";
import { toast } from "react-toastify";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { RotatingLines } from "react-loader-spinner";

const AddCardNew = () => {
  const [cvc, setCvc] = useState("");
  const [expiry, setExpiry] = useState("");
  const [focus, setFocus] = useState("");
  const [name, setName] = useState("");
  const [cardType, setCardType] = useState("");
  const [number, setNumber] = useState("");
  const [address, setAddress] = useState("");
  const [makePrimaryCheck, setMakePrimaryCheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [cityList, setCityList] = useState([]);
  const [countryList, setCountryList] = useState([
    { country_id: "", state_name: "" },
  ]);
  const [stateList, setStateList] = useState([
    {
      mms_city_id: "",
      city_name: "",
    },
  ]);
  const [inputValues, setInputValues] = useState({
    country: "",
    state: "",
    city: "",
    zipcode: "",
  });

  // VALIDATION
  const [cardNumberError, setCardNumberError] = useState("");
  const [cardCVVError, setCardCVVError] = useState("");
  const [cardHolderError, setCardHolderError] = useState("");
  const [cardExpiryError, setCardExpiryError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [stateError, setStateError] = useState("");
  const [cityError, setCityError] = useState("");
  const [zipcodeError, setZipcodeError] = useState("");

  const Uid = userId();

  // Detect Card type
  const detectCardType = (cardNumber) => {
    const visaPattern = /^4[0-9]{12}(?:[0-9]{3})?$/;
    const mastercardPattern = /^5[1-5][0-9]{14}$/;
    const discoverPattern = /^6(?:011|5[0-9]{2})[0-9]{12}$/;
    const amexPattern = /^3[47][0-9]{13}$/;
    const dinersClubPattern = /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/;
    const jcbPattern = /^(?:2131|1800|35\d{3})\d{11}$/;
    const maestroPattern = /^(?:5[06789]|6[1-5])[0-9]{14}$/;
    const unionPayPattern = /^62[0-9]{14,17}$/;

    if (visaPattern.test(cardNumber)) {
      return "Visa";
    } else if (mastercardPattern.test(cardNumber)) {
      return "Mastercard";
    } else if (discoverPattern.test(cardNumber)) {
      return "Discover";
    } else if (amexPattern.test(cardNumber)) {
      return "American Express";
    } else if (dinersClubPattern.test(cardNumber)) {
      return "Diners Club";
    } else if (jcbPattern.test(cardNumber)) {
      return "JCB";
    } else if (maestroPattern.test(cardNumber)) {
      return "Maestro";
    } else if (unionPayPattern.test(cardNumber)) {
      return "UnionPay";
    } else {
      return "";
    }
  };

  // check for make primary function
  const onMakePrimary = (e) => {
    let val = e.target.checked;
    setMakePrimaryCheck(val);
  };

  const handleInputFocus = (e) => {
    setFocus(e.target.name);
  };

  const onCountry = (e) => {
    let val = e.target.value;
    setInputValues((ps) => {
      return { ...ps, country: val };
    });
    setCountryError("");
  };

  const onZipcode = (e) => {
    let val = e.target.value.slice(0, 8).replace(/\D/g, "");
    setInputValues((ps) => {
      return { ...ps, zipcode: val };
    });
    setZipcodeError("");
  };

  const CityInputHandler = (e) => {
    let val = e.target.value;

    setInputValues((ps) => {
      return { ...ps, city: val };
    });
    setCityError("");
  };

  const onState = (e) => {
    let val = e.target.value;
    setInputValues((ps) => {
      return { ...ps, state: val };
    });
    getCity(val);
    setStateError("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "number":
        let val2 = parseInt(value?.slice(0, 16));
        const detectedCardType = detectCardType(val2);
        setCardType(detectedCardType);
        setNumber(val2);
        setCardNumberError("");
        break;
      case "cvc":
        let val1 = value.replace(/\D/g, "");
        setCvc(val1);
        setCardCVVError("");
        break;
      case "name":
        setName(value);
        setCardHolderError("");
        break;
      case "expiry":
        let val = value.replace(
          /^(\d\d)(\/?)(\d{0,2}).*$/,
          (fullMatch, p1, p2, p3) => {
            let replacedValue = p1;
            if (p2 === "/" && p3) {
              replacedValue += "/" + p3;
            }
            return replacedValue;
          }
        );
        setExpiry(val);
        setCardExpiryError("");
        break;
      case "address":
        setAddress(value);
        setAddressError("");
        break;
    }
  };

  const OnZipcodeKeyDown = (e) => {
    if (e.key === "-" || e.key === "+") {
      e.preventDefault();
    }
  };

  function formatString(e) {
    var inputChar = String.fromCharCode(e.keyCode);
    var code = e.keyCode;
    var allowedKeys = [8];
    if (allowedKeys.indexOf(code) !== -1) {
      return;
    }

    e.target.value = e.target.value
      .replace(
        /^([1-9]\/|[2-9])$/g,
        "0$1/" // 3 > 03/
      )
      .replace(
        /^(0[1-9]|1[0-2])$/g,
        "$1/" // 11 > 11/
      )
      .replace(
        /^([0-1])([3-9])$/g,
        "0$1/$2" // 13 > 01/3
      )
      .replace(
        /^(0?[1-9]|1[0-2])([0-9]{2})$/g,
        "$1/$2" // 141 > 01/41
      )
      .replace(
        /^([0]+)\/|[0]+$/g,
        "0" // 0/ > 0 and 00 > 0
      )
      .replace(
        /[^\d\/]|^[\/]*$/g,
        "" // To allow only digits and `/`
      )
      .replace(
        /\/\//g,
        "/" // Prevent entering more than 1 `/`
      );
  }

  const navigate = useNavigate();

  // Cancel function
  const cancelButton = () => {
    navigate("/my-profile/subscription/checkOutPage");
  };

  // Submit function
  const handleSubmit = (event) => {
    event.preventDefault();
    const expiryDateRegex = /^(0[1-9]|1[0-2])\/(2[3-9]|[3-9]\d)$/;
    const nameRegex = /^[a-zA-Z0-9 ]+$/;
    const cardNumberRegex = /^\d{12,19}$/;
    let check = true;

    if (!number) {
      setCardNumberError("Please enter card number!");
      check = false;
      window.scrollTo(0, 0);
    } else if (cardNumberRegex.test(number) === false) {
      setCardNumberError("Please enter a valid card number!");
      check = false;
    } else {
      setCardNumberError("");
    }

    if (!cvc) {
      setCardCVVError("Please enter CVV!");
      window.scrollTo(0, 0);
      check = false;
    } else {
      setCardCVVError("");
    }

    if (!name) {
      setCardHolderError("Please enter card holder name!");
      check = false;
    } else if (nameRegex.test(name) === false) {
      setCardHolderError("Please enter valid name!");
      check = false;
    } else {
      setCardHolderError("");
    }

    // This condition if for Expiry date
    const currentYear = new Date().getFullYear();

    const [enteredMonth, enteredYear] = expiry.split("/");
    const currentYearLastTwoDigits = currentYear % 100;
    const currentMonth = new Date().getMonth() + 1;

    const enteredMonthNumber = parseInt(enteredMonth, 10);
    const currentMonthNumber = parseInt(currentMonth, 10);

    const isValidYear =
      enteredYear > currentYearLastTwoDigits ||
      (enteredYear >= currentYearLastTwoDigits &&
        enteredMonthNumber >= currentMonthNumber);

    if (!expiry) {
      setCardExpiryError("Please enter expiry date!");
      check = false;
    } else if (!isValidYear) {
      setCardExpiryError("Please enter a valid expiry date!");
      check = false;
      return;
    } else if (expiryDateRegex.test(expiry) === false) {
      setCardExpiryError("Please enter a valid expiry date!");
      check = false;
    } else {
      setCardExpiryError("");
    }

    if (!address) {
      setAddressError("Please enter address!");
      check = false;
    } else {
      setAddressError("");
    }

    if (!inputValues.country) {
      setCountryError("Please select a country!");
      check = false;
    } else {
      setCountryError("");
    }

    if (!inputValues.state) {
      setStateError("Please select a state!");
      check = false;
    } else {
      setStateError("");
    }

    if (!inputValues.city) {
      setCityError("Please enter a city name!");
      check = false;
    } else {
      setCityError("");
    }

    if (!inputValues.zipcode) {
      setZipcodeError("Please enter zipcode!");
      check = false;
    } else {
      setZipcodeError("");
    }

    if (check === true) {
      const data = {
        user_id: parseInt(Uid),
        card_number: number,
        expiry_date: expiry.trim(),
        card_address: address.trim(),
        zipcode: inputValues.zipcode.trim(),
        is_default: makePrimaryCheck === true ? 1 : 0,
        card_type: cardType ? cardType.trim() : "Unknown",
        card_holder_name: name.trim(),
        country_code: parseInt(inputValues.country),
        state_code: parseInt(inputValues.state),
        card_city: inputValues.city.trim(),
      };
      AddNewCardApiHandler(data);
    }
  };

  // Get country API
  const GetCountryAPIHandler = async () => {
    const getCountry = await GetCountry();

    setCountryList(getCountry.data);
  };

  // Get State API
  const GetStateApiHandler = async () => {
    const data = {
      country_id: parseInt(inputValues.country),
    };
    const getState = await (data,
    () => {
      navigate("/");
    });
    setStateList(getState.data, () => {
      navigate("/");
    });
  };

  // Get City API
  const getCity = async (state_id) => {
    const dat = {
      state_id: state_id,
    };
    const cityData = await GetCity(dat, () => {
      navigate("/");
    });
    setCityList(cityData.data);
  };

  // Add card API
  const AddNewCardApiHandler = async (data) => {
    setLoading(true);
    const AddNewCardApiRes = await AddNewCardApi(data, () => {
      navigate("/");
    });
    if (AddNewCardApiRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (AddNewCardApiRes.success === true) {
        toast.success(AddNewCardApiRes.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        navigate("/my-profile/subscription/checkOutPage");
        setLoading(false);
      } else {
        toast.error(AddNewCardApiRes.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    GetCountryAPIHandler();
  }, []);

  useEffect(() => {
    GetStateApiHandler();
  }, [inputValues.country]);

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/my-profile/subscription/checkOutPage"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">Add New Card</p>
          <div className="acc-dashboard mt-4 addNewCard">
            <div id="PaymentForm">
              <form onSubmit={handleSubmit}>
                <div className="CardForm">
                  <div>
                    <label>
                      Card Number <span className="star-required">*</span>
                    </label>
                    <input
                      type="number"
                      name="number"
                      placeholder="Enter Card Number"
                      onChange={handleInputChange}
                      onFocus={handleInputFocus}
                      maxLength={16}
                      onWheel={(e) => e.target.blur()}
                      className="Card-Number"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={number}
                    />
                    <ErrorLabel ErrorDisplay={cardNumberError} />
                  </div>
                  <div>
                    <label>
                      CVV <span className="star-required">*</span>
                    </label>
                    <input
                      maxLength={4}
                      type="text"
                      name="cvc"
                      placeholder="CVV"
                      onChange={handleInputChange}
                      onFocus={handleInputFocus}
                      className="Card-CVV"
                      value={cvc}
                    />
                    <ErrorLabel ErrorDisplay={cardCVVError} />
                  </div>
                  <div>
                    <label>
                      Card Holder Name <span className="star-required">*</span>
                    </label>
                    <input
                      type="tel"
                      name="name"
                      placeholder="Enter Name"
                      onChange={handleInputChange}
                      onFocus={handleInputFocus}
                      className="Card-Name"
                      maxLength={30}
                      value={name}
                    />
                    <ErrorLabel ErrorDisplay={cardHolderError} />
                  </div>
                  <div>
                    <label>
                      Expiry Date <span className="star-required">*</span>
                    </label>
                    <input
                      type="tel"
                      name="expiry"
                      placeholder="MM/YY"
                      onChange={handleInputChange}
                      onFocus={handleInputFocus}
                      className="Card-expiry"
                      maxLength={5}
                      value={expiry}
                      onKeyUp={(e) => formatString(e)}
                    />
                    <ErrorLabel ErrorDisplay={cardExpiryError} />
                  </div>
                  <div className="address-input">
                    <label>
                      Address <span className="star-required">*</span>
                    </label>
                    <textarea
                      className="address-textarea"
                      type="text"
                      name="address"
                      placeholder="Enter Your Address"
                      onChange={handleInputChange}
                      onFocus={handleInputFocus}
                      value={address}
                      maxLength={200}
                      rows={1}
                    />
                    <ErrorLabel ErrorDisplay={addressError} />
                  </div>
                  <div className="Card-country">
                    <label>
                      Country <span className="star-required">*</span>
                    </label>
                    <Form.Select
                      aria-label="Default select example"
                      onChange={onCountry}
                      value={inputValues.country}
                    >
                      <option disabled value="">
                        Select Country
                      </option>
                      {countryList?.length != 0 ? (
                        countryList?.map((data) => {
                          return (
                            <option
                              value={data.country_id}
                              key={data.country_id}
                            >
                              {data.country_name}
                            </option>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </Form.Select>
                    <ErrorLabel ErrorDisplay={countryError} />
                  </div>
                  <div className="Card-country">
                    <label>
                      State/Province <span className="star-required">*</span>
                    </label>
                    <Form.Select
                      aria-label="Default select example"
                      onChange={onState}
                      value={inputValues.state}
                    >
                      <option disabled value="">
                        Select State
                      </option>
                      {stateList?.length > 0 ? (
                        stateList.map((data) => {
                          return (
                            <option value={data.state_id} key={data.state_id}>
                              {data.state_name}
                            </option>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </Form.Select>
                    <ErrorLabel ErrorDisplay={stateError} />
                  </div>
                  <div className="card-city">
                    <AutoCompleteInput
                      CityList={cityList}
                      EditFlag={true}
                      EditCity={inputValues.city}
                      ApiCity={""}
                      onCityFuc={CityInputHandler}
                      ErrDisplay={cityError}
                      NameFlag={"sl_city"}
                      Md={"4"}
                    />
                  </div>
                  <div>
                    <label style={{ marginBottom: "2px" }}>
                      Zipcode <span className="star-required">*</span>
                    </label>
                    <input
                      type="number"
                      name="expiry"
                      placeholder="Enter Zipcode"
                      onChange={onZipcode}
                      value={inputValues.zipcode}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={OnZipcodeKeyDown}
                      className="Card-expiry"
                      inputMode="numeric"
                      pattern="[0-9]*"
                    />
                    <ErrorLabel ErrorDisplay={zipcodeError} />
                  </div>
                </div>
                <Cards
                  cvc={cvc}
                  expiry={expiry}
                  focused={focus}
                  name={name}
                  number={number}
                />
                <div className="Tier-checkbox">
                  <Form.Check
                    aria-label="option 1"
                    className="orange-checkbox"
                    onChange={onMakePrimary}
                    checked={makePrimaryCheck}
                  />
                  <p>Make it primary card</p>
                </div>
                <div className="newCardButtons">
                  <button type="submit">
                    {" "}
                    {loading === true ? (
                      <RotatingLines
                        strokeColor="white"
                        width={20}
                        visible={true}
                      />
                    ) : (
                      "Add Card"
                    )}
                  </button>
                  <button onClick={cancelButton}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default AddCardNew;
